import React from "react";
import Navbar from '../components/Navbar';
import BlogPost from '../components/BlogPost'
import Footer from '../components/Footer';

export default function BlogContent() {
    return (
        <div className="react-blog-wrapper">
            <Navbar />
            <BlogPost />
            <Footer />
        </div>
    )
}